import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFamilyView } from '../ducks';
import { selectFamilyView } from '../selectors';

export function FamilyViewToggle() {
  const dispatch = useDispatch();
  const familyView = useSelector(selectFamilyView);

  return (
    <label className="family-view-toggle" data-testid="family-view-toggle">
      <input
        type="checkbox"
        checked={familyView}
        onChange={() => dispatch(toggleFamilyView())}
        aria-label="Toggle family view"
      />
      <span className="family-view-toggle__label">
        {familyView ? 'Family' : 'My Day'}
      </span>
    </label>
  );
}
